// Curated peer-reviewed research references for the peptides in the RegenX catalog.
// References include PMID (PubMed ID) where available. All links go to PubMed.
// This is reference literature, not clinical recommendation.

export const RESEARCH_DATA = [
  {
    slug: "retatrutide",
    name: "Retatrutide (LY3437943)",
    summary:
      "A novel triple agonist at GLP-1, GIP, and glucagon receptors. Recent landmark trials demonstrate substantial effects on body weight and glycemic control in humans.",
    papers: [
      {
        authors: "Jastreboff AM, Kaplan LM, Frías JP, et al.",
        title:
          "Triple-Hormone-Receptor Agonist Retatrutide for Obesity — A Phase 2 Trial.",
        journal: "N Engl J Med",
        year: "2023",
        ref: "389(6):514–526",
        pmid: "37366315",
      },
      {
        authors: "Rosenstock J, Frias J, Jastreboff AM, et al.",
        title:
          "Retatrutide, a GIP, GLP-1 and glucagon receptor agonist, for people with type 2 diabetes: a randomised, double-blind, placebo and active-controlled, parallel-group, phase 2 trial conducted in the USA.",
        journal: "Lancet",
        year: "2023",
        ref: "402(10401):529–544",
        pmid: "37385280",
      },
      {
        authors: "Coskun T, Urva S, Roell WC, et al.",
        title:
          "LY3437943, a novel triple glucagon, GIP, and GLP-1 receptor agonist for glycemic control and weight loss: From discovery to clinical proof of concept.",
        journal: "Cell Metab",
        year: "2022",
        ref: "34(9):1234–1247.e9",
        pmid: "35985340",
      },
    ],
  },
  {
    slug: "tesamorelin",
    name: "Tesamorelin",
    summary:
      "A stabilized GHRH analogue with extensive clinical literature, most notably in studies of visceral adipose tissue and lipid biology.",
    papers: [
      {
        authors: "Stanley TL, Feldpausch MN, Oh J, et al.",
        title:
          "Effects of tesamorelin on visceral fat and liver fat in HIV-infected patients with abdominal fat accumulation: a randomized clinical trial.",
        journal: "JAMA",
        year: "2014",
        ref: "312(4):380–389",
        pmid: "25038357",
      },
      {
        authors: "Falutz J, Allas S, Blot K, et al.",
        title:
          "Effects of tesamorelin (TH9507), a growth hormone-releasing factor analog, in HIV-infected patients with excess abdominal fat: a pooled analysis of two multicenter, double-blind placebo-controlled phase 3 trials with safety extension data.",
        journal: "J Clin Endocrinol Metab",
        year: "2010",
        ref: "95(9):4291–4304",
        pmid: "20554713",
      },
    ],
  },
  {
    slug: "mots-c",
    name: "MOTS-c",
    summary:
      "A mitochondrial-derived peptide implicated in metabolic homeostasis, AMPK signaling, and exercise-induced adaptations.",
    papers: [
      {
        authors: "Lee C, Zeng J, Drew BG, et al.",
        title:
          "The mitochondrial-derived peptide MOTS-c promotes metabolic homeostasis and reduces obesity and insulin resistance.",
        journal: "Cell Metab",
        year: "2015",
        ref: "21(3):443–454",
        pmid: "25738459",
      },
      {
        authors: "Reynolds JC, Lai RW, Woodhead JST, et al.",
        title:
          "MOTS-c is an exercise-induced mitochondrial-encoded regulator of age-dependent physical decline and muscle homeostasis.",
        journal: "Nat Commun",
        year: "2021",
        ref: "12(1):470",
        pmid: "33473109",
      },
    ],
  },
  {
    slug: "ghk-cu",
    name: "GHK-Cu (Copper Peptide)",
    summary:
      "A naturally occurring copper-binding tripeptide widely studied in dermal remodeling, collagen biology, and tissue repair research.",
    papers: [
      {
        authors: "Pickart L, Vasquez-Soltero JM, Margolina A.",
        title:
          "GHK Peptide as a Natural Modulator of Multiple Cellular Pathways in Skin Regeneration.",
        journal: "BioMed Research International",
        year: "2015",
        ref: "2015:648108",
        pmid: "26236730",
      },
      {
        authors: "Pickart L.",
        title:
          "The human tri-peptide GHK and tissue remodeling.",
        journal: "J Biomater Sci Polym Ed",
        year: "2008",
        ref: "19(8):969–988",
        pmid: "18644225",
      },
    ],
  },
  {
    slug: "kpv",
    name: "KPV (α-MSH 11–13)",
    summary:
      "The C-terminal tripeptide fragment of α-melanocyte-stimulating hormone, studied for anti-inflammatory and mucosal repair properties.",
    papers: [
      {
        authors: "Kannengiesser K, Maaser C, Heidemann J, et al.",
        title:
          "Melanocortin-derived tripeptide KPV has anti-inflammatory potential in murine models of inflammatory bowel disease.",
        journal: "Inflamm Bowel Dis",
        year: "2008",
        ref: "14(3):324–331",
        pmid: "18092346",
      },
      {
        authors: "Dalmasso G, Charrier-Hisamuddin L, Nguyen HT, et al.",
        title:
          "PepT1-mediated tripeptide KPV uptake reduces intestinal inflammation.",
        journal: "Gastroenterology",
        year: "2008",
        ref: "134(1):166–178",
        pmid: "18061177",
      },
    ],
  },
  {
    slug: "semax",
    name: "Semax (ACTH 4–7 analogue)",
    summary:
      "A heptapeptide analogue of ACTH(4-7) studied for nootropic and neurotrophic effects in the central nervous system.",
    papers: [
      {
        authors: "Dolotov OV, Karpenko EA, Inozemtseva LS, et al.",
        title:
          "Semax, an analogue of adrenocorticotropin (4-10), binds specifically and increases levels of brain-derived neurotrophic factor protein in rat basal forebrain.",
        journal: "J Neurochem",
        year: "2006",
        ref: "97(Suppl 1):82–86",
        pmid: "16635254",
      },
      {
        authors: "Shadrina MI, Dolotov OV, Grivennikov IA, et al.",
        title:
          "Rapid induction of neurotrophin mRNAs in rat glial cell cultures by Semax, an adrenocorticotropic hormone analog.",
        journal: "Neurosci Lett",
        year: "2001",
        ref: "308(2):115–118",
        pmid: "11457573",
      },
    ],
  },
  {
    slug: "bpc-157",
    name: "BPC-157",
    summary:
      "A 15-amino-acid peptide derived from a protective protein in gastric juice. One of the most extensively studied peptides in pre-clinical tissue-repair and gastrointestinal research.",
    papers: [
      {
        authors: "Sikiric P, Seiwerth S, Rucman R, et al.",
        title:
          "Stable gastric pentadecapeptide BPC 157: novel therapy in gastrointestinal tract.",
        journal: "Curr Pharm Des",
        year: "2011",
        ref: "17(16):1612–1632",
        pmid: "21548867",
      },
      {
        authors: "Chang CH, Tsai WC, Lin MS, et al.",
        title:
          "The promoting effect of pentadecapeptide BPC 157 on tendon healing involves tendon outgrowth, cell survival, and cell migration.",
        journal: "J Appl Physiol (1985)",
        year: "2011",
        ref: "110(3):774–780",
        pmid: "21030672",
      },
      {
        authors: "Sikiric P, Seiwerth S, Rucman R, et al.",
        title:
          "Brain-gut Axis and Pentadecapeptide BPC 157: Theoretical and Practical Implications.",
        journal: "Curr Neuropharmacol",
        year: "2016",
        ref: "14(8):857–865",
        pmid: "27138887",
      },
    ],
  },
  {
    slug: "klow",
    name: "KLOW (multi-peptide blend)",
    summary:
      "KLOW is a research-only multi-peptide blend; no single peer-reviewed paper exists for the formulated combination. Below are key references for the individual peptide components.",
    papers: [
      {
        authors: "Kannengiesser K, Maaser C, Heidemann J, et al.",
        title:
          "Melanocortin-derived tripeptide KPV has anti-inflammatory potential in murine models of inflammatory bowel disease.",
        journal: "Inflamm Bowel Dis",
        year: "2008",
        ref: "14(3):324–331",
        pmid: "18092346",
        component: "KPV",
      },
      {
        authors: "Sikiric P, Seiwerth S, Rucman R, et al.",
        title:
          "Stable gastric pentadecapeptide BPC 157: novel therapy in gastrointestinal tract.",
        journal: "Curr Pharm Des",
        year: "2011",
        ref: "17(16):1612–1632",
        pmid: "21548867",
        component: "BPC-157",
      },
      {
        authors: "Pickart L, Vasquez-Soltero JM, Margolina A.",
        title:
          "GHK Peptide as a Natural Modulator of Multiple Cellular Pathways in Skin Regeneration.",
        journal: "BioMed Research International",
        year: "2015",
        ref: "2015:648108",
        pmid: "26236730",
        component: "GHK-Cu",
      },
    ],
  },
  {
    slug: "ipamorelin",
    name: "Ipamorelin",
    summary:
      "A selective growth-hormone secretagogue and ghrelin mimetic, studied for its pulsatile GH-releasing effect with minimal cortisol or prolactin response.",
    papers: [
      {
        authors: "Raun K, Hansen BS, Johansen NL, et al.",
        title:
          "Ipamorelin, the first selective growth hormone secretagogue.",
        journal: "Eur J Endocrinol",
        year: "1998",
        ref: "139(5):552–561",
        pmid: "9849822",
      },
      {
        authors: "Sinha DK, Balasubramanian A, Tatem AJ, et al.",
        title:
          "Beyond the androgen receptor: the role of growth hormone secretagogues in the modern management of body composition in hypogonadal males.",
        journal: "Transl Androl Urol",
        year: "2020",
        ref: "9(Suppl 2):S149–S159",
        pmid: "32257855",
      },
    ],
  },
];
